import {
  createContext,
  useContext,
  useReducer,
  type Dispatch,
  type ReactNode,
} from "react";

import type { InteriorDesignerState, InteriorDesignerAction } from "./types";
import { interiorDesignerReducer, createInitialState } from "./reducer";

type InteriorDesignerContextValue = {
  state: InteriorDesignerState;
  dispatch: Dispatch<InteriorDesignerAction>;
};

const InteriorDesignerContext = createContext<
  InteriorDesignerContextValue | undefined
>(undefined);

type InteriorDesignerProviderProps = {
  photoId: string;
  children: ReactNode;
};

export function InteriorDesignerProvider({
  photoId,
  children,
}: InteriorDesignerProviderProps) {
  const [state, dispatch] = useReducer(
    interiorDesignerReducer,
    { photoId },
    createInitialState,
  );

  return (
    <InteriorDesignerContext.Provider value={{ state, dispatch }}>
      {children}
    </InteriorDesignerContext.Provider>
  );
}

export const useInteriorDesigner = (): InteriorDesignerContextValue => {
  const context = useContext(InteriorDesignerContext);
  if (!context) {
    throw new Error(
      "useInteriorDesigner must be used within an InteriorDesignerProvider",
    );
  }
  return context;
};
